module.exports = __webpack_public_path__ + "static/media/bus-alt.b3c9123c.svg";